import type * as ents from '@attain-apps/entities'
import type * as sunburst from 'sunburst-chart'

/**
 * Gets/creates the root {@link sunburst.Node} from
 * {@link ents.core.display.chart.data.Of}
 * {@link ents.core.display.chart.Type.Sunburst}
 */
export function getRootNode({
  root,
}: ents.core.display.chart.data.Of<ents.core.display.chart.Type.Sunburst> = {}):
  | sunburst.Node
  | undefined {
  return root && _transformNode(root)
}

/**
 * Converts a {@link ents.core.display.chart.data.Tree.Node} into a {@link sunburst.Node}
 */
function _transformNode(
  node: ents.core.display.chart.data.Tree.Node,
  {
    slice,
    level = 0,
  }: {
    // Used to determine color
    readonly slice?: number
    readonly level?: number
  } = {},
): sunburst.Node {
  return {
    children: node.children?.map((child, i) =>
      _transformNode(child, { level: level + 1, slice: slice ?? i }),
    ),
    description: node.description,
    level,
    name: node.name,
    slice,
    weight: node.weight,
  }
}
